import React from "react";
import ControlFeedback from "./ControlFeedback";
import { ControlProps } from "./Types";

const CheckboxControl: React.FC<ControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur }) => {

    function check() {
        if (disabled !== true) onChange(true);
    }

    function uncheck() {
        if (disabled !== true) onChange(false);
    }

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    let classNames = 'checkbox-control'
    if (value === true)
        classNames += ' checked'
    if (disabled === true)
        classNames += ' disabled'
    if (isValid === false)
        classNames += ' has-errors'

    return (
        <div style={{ width: width }} className={classNames} >
            <label>
                <span className='check' onClick={uncheck} />
                <span className='box' onClick={check} />
            </label>
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default CheckboxControl;